import { useAccountTypeStructures } from "@features/tickets/shared/hooks/useAccountTypeStructures";
import { BANK_ACCOUNT_TYPE } from "./banks.constants";

export function useBankStructures() {
  return useAccountTypeStructures(BANK_ACCOUNT_TYPE);
}
